import appConst from "../Utilities/appConst.json";

export const areaCodesArray = [
  { value: "050", label: "050" },
  { value: "051", label: "051" },
  { value: "052", label: "052" },
  { value: "053", label: "053" },
  { value: "054", label: "054" },
  { value: "055", label: "055" },
  { value: "058", label: "058" },
];

export const numricFieldArray = [
  appConst.BUILDING_NUM,
  appConst.APARTMENT_NUM,
  appConst.ZIP,
  appConst.PHONE_NUMBER,
  appConst.COMPANY_ID,
];

export const isNotRequiredFieldArray = [
  appConst.APARTMENT_NUMBER,
  appConst.ZIP,
];
